'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var template = require('../../templates/error.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-error',
    events: {
        'click .close': 'closeModal'
    },
    /**
     * Initialize Error View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.router = options.router;
        this.copyCms = options.copyCms;
        this.type = options.type;

        this.listenTo( this.copyCms, 'change:text change:sid change:language', this.render );
    },
    /**
     * Render Error View
     */
    render: function () {
        var modal = this.copyCms.get('text').modal;
        var errorCopy = this.copyCms.get('text')['views_error'][this.type];
        this.$el.html(template( _.extend({
            faq: this.copyCms.get('text')[ 'views_vote_grid' ][ 'faq' ],
            modal: modal
        }, errorCopy )));

        return this;
    },
    /**
     * Close Modal
     */
    closeModal: function(e) {
        e.preventDefault();

        this.trigger('closeModal', {});
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/error.js